import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Visual breadcrumbs. Pair with breadcrumbJsonLd() from Seo.js for SEO.
 *
 *   <Breadcrumbs items={[
 *     { name: "Accueil", path: "/" },
 *     { name: "Catégorie", path: "/categorie/jeux" },
 *     { name: "Produit" }, // last has no path
 *   ]} />
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Fil d'Ariane"
      data-testid="breadcrumbs"
      className="text-xs text-ink/70"
    >
      <ol className="flex items-center flex-wrap gap-1">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {it.path && !isLast ? (
                <Link to={it.path} className="hover:underline" data-testid={`breadcrumb-${i}`}>
                  {it.name}
                </Link>
              ) : (
                <span className="text-ink" data-testid={`breadcrumb-${i}`}>{it.name}</span>
              )}
              {!isLast && <ChevronRight size={12} className="text-ink/40" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
